// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"2b30963a","120":"235553ae","139":"b5350b1b","147":"ce7a2c3a","481":"e978354e","607":"f12e863d","764":"b09df901","807":"b7338638","818":"7193111a","900":"fd1baf32","971":"fb3a2779"}[chunkId] + ".chunk.js";
};